import z from 'zod';

import { EServiceRequestStatus } from '@enums/serviceRequest.enum';
import { paginationSchema } from '@schemas/pagination.schema';

export const getAllServiceRequestsSchema = paginationSchema.extend({
  status: z.enum(EServiceRequestStatus).array().nonempty().optional(),
});

export type GetAllServiceRequestsParams = z.infer<
  typeof getAllServiceRequestsSchema
>;
